import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getForgotPasswordStatus } from 'store/apiStatus';
import { forgotPasswordRequest } from 'store/auth';

import { ForgotPassword, ForgotPasswordSuccess } from 'components';

export const ForgotPasswordContainer = ({ status, onForgotPassword }) => {
  return status.success ? (
    <ForgotPasswordSuccess />
  ) : (
    <ForgotPassword status={status} onSubmit={onForgotPassword} />
  );
};

ForgotPasswordContainer.propTypes = {
  status: PropTypes.object.isRequired,
  onForgotPassword: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  status: getForgotPasswordStatus(state)
});

const mapDispatchToProps = {
  onForgotPassword: forgotPasswordRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(
  ForgotPasswordContainer
);



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordContainer/ForgotPasswordContainer.js